(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/utils.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/utils.js');

const { REMOVED, REVIEW, DOWNLOAD, DENIED, UNKNOWN } = svs.ticket_partner.myOrders.constants.TEXTS.ORDER_STATES;

const getOrderStatus = (state) => {
  switch (state) {
    case -5:
      return REMOVED;
    case -4:
      return DOWNLOAD;
    case -3:
    case -2:
      return REVIEW;
    case -1:
      return DENIED;
    default:
      return UNKNOWN;
  }
};

const validateCode = async (code) => {
  let api = 5;
  if (svs.core.detect.feature('ft-its-api-version')) {
    api = 6;
  }
  const options = {
    method: 'GET',
    path: `/voucher/${api}/getvoucher?voucherId=${code}`
  };
  return await svs.core.jupiter.callAsync(options);
};

const mapValidateCodeError = (error) => {
  const code = error.code;
  switch (code) {
    case '26 102':
    case '26 3':
      return 'Ej giltig presentkod';
    default:
      return 'Tekniskt fel, var god försök senare.';
  }
};

const mapClaimedStatus = (voucherData) => {
  const { cashingCustomerId, cashingRetailerId, lastStateChange } = voucherData;
  let customerType;
  if (cashingRetailerId) {
    customerType = 'ombud';
  }
  if (cashingCustomerId) {
    customerType = 'onlinekund';
  }
  return `Inlöst av ${customerType} ${svs.utils.date.SimpleDate(new Date(lastStateChange))} ${svs.utils.date.SimpleTime(new Date(lastStateChange))}`;
};

const mapVoucherStatus = (voucherData) => {
  const { state } = voucherData;
  switch (state) {
    case 'ACTIVE':
      return 'Oinlöst';
    case 'CLAIMED':
      return mapClaimedStatus(voucherData);
    case 'EXPIRED':
      return 'Utgången';
    default:
      return 'Okänd';
  }
};

svs.ticket_partner.myOrders.utils = {
  getOrderStatus,
  validateCode,
  mapValidateCodeError,
  mapVoucherStatus
};


 })(window);